




















import { Result } from '@empathybroker/tsclient-search';

import { UiIconButton } from '../keen-ui';
import ExplainResultsRow from './explain-results-row.component.vue';

export default {
  name: 'explain-results-header-row',
  props: {
    results: {
      type: Array,
      required: true
    }
  },
  components: {
    ExplainResultsRow,
    UiIconButton
  },
  computed: {
    resultIds: function (): string[] {
      return this.results.map((result: Result) => result.id);
    }
  },
  data: function () {
    return {
      defaultResultImageUrl: require('../../assets/media/image/image-not-found.svg')
    };
  },
  methods: {
    getResultImageUrl: function (result: Result): string {
      return (result.imageUrl || this.defaultResultImageUrl);
    },
    onResultImageError: function (event): void {
      event.target.src = this.defaultResultImageUrl;
    }
  }
};
